import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import { navLinks } from "../../data/mock";
import { openContactModal } from "../../lib/contactBus";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const loc = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => { setOpen(false); }, [loc.pathname]);

  return (
    <header
      className={`sticky top-0 z-40 transition-colors duration-300 ${
        scrolled ? "bg-[var(--off-white)]/95 backdrop-blur-md border-b border-[var(--slate-300)]" : "bg-[var(--off-white)] border-b border-[var(--slate-300)]"
      }`}
    >
      <div className="max-w-[1480px] mx-auto px-6 lg:px-10">
        <nav className="h-[72px] flex items-center justify-between gap-8">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2.5 group">
            <div className="w-9 h-9 bg-[var(--slate-900)] flex items-center justify-center group-hover:bg-[var(--terracotta)] transition-colors">
              <span className="font-display text-[var(--off-white)] text-[22px] tracking-tight">E</span>
            </div>
            <div className="leading-none">
              <div className="font-display text-[22px] tracking-wide text-[var(--slate-900)] uppercase">Edge Developer</div>
              <div className="font-mono-sans text-[9px] text-[var(--terracotta)] mt-0.5">LLC — EST. 2014</div>
            </div>
          </Link>

          {/* Center nav */}
          <ul className="hidden lg:flex items-center gap-1">
            {navLinks.map((l) => (
              <li key={l.to}>
                <NavLink
                  to={l.to}
                  end={l.to === "/"}
                  className={({ isActive }) =>
                    `px-4 py-2 font-mono-sans text-[11.5px] font-semibold transition-colors ${
                      isActive ? "text-[var(--terracotta)]" : "text-[var(--slate-900)] hover:text-[var(--terracotta)]"
                    }`
                  }
                >
                  {l.label.toUpperCase()}
                </NavLink>
              </li>
            ))}
          </ul>

          {/* Right */}
          <div className="hidden lg:flex items-center gap-5">
            <a href="tel:+15073518787" className="flex items-center gap-2 font-mono-sans text-[11.5px] font-semibold text-[var(--slate-900)] hover:text-[var(--terracotta)] transition-colors">
              <Phone size={13} /> (507) 351-8787
            </a>
            <button onClick={openContactModal} className="btn-terracotta !py-2.5 !px-5">
              Start Project
            </button>
          </div>

          {/* Mobile toggle */}
          <button className="lg:hidden p-2 text-[var(--slate-900)]" onClick={() => setOpen(!open)} aria-label="toggle menu">
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </nav>
      </div>

      {/* Mobile menu */}
      {open && (
        <div className="lg:hidden border-t border-[var(--slate-300)] bg-[var(--off-white)] px-6 py-6 space-y-1">
          {navLinks.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              className={({ isActive }) =>
                `block py-3 font-mono-sans text-[13px] font-semibold border-b border-[var(--slate-300)] ${
                  isActive ? "text-[var(--terracotta)]" : "text-[var(--slate-900)]"
                }`
              }
            >
              {l.label.toUpperCase()}
            </NavLink>
          ))}
          <button onClick={openContactModal} className="btn-terracotta mt-4 w-full justify-center">
            Start Project
          </button>
        </div>
      )}
    </header>
  );
}
